import React, { FC } from "react"
import { observer } from "mobx-react-lite"
import { Appearance, ViewStyle } from "react-native"
import { Screen, Text } from "../../components"
// import { useStores } from "../../models"
import { color } from "../../theme"
import { CompositeScreenProps } from "@react-navigation/native"

const ROOT: ViewStyle = {
  backgroundColor: color.palette.black,
  flex: 1,
}

export const ScratchScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function ScratchScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={color.primary}
      statusBar={"light-content"}
    >
      <Text colorScheme={colorScheme} text="Scratch" />
    </Screen>
  )
})
